import React from 'react';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import AddBlockIcon from '../../../assets/icons/Add-Block.svg';

function SchedulerHeaderActions({
  onAdd,
  onUndo,
  canUndo,
  onImport,
  onExport,
  showAdd = true,
}) {
  const buttons = [
    {
      key: 'add',
      cssClass: 'ca-scheduler-header__add-button',
      customIcon: AddBlockIcon,
      disabled: false,
      onClick: onAdd,
      title: 'New Block',
    },
    {
      key: 'undo',
      cssClass: 'ca-scheduler-header__undo-button',
      iconCss: 'e-icons e-undo',
      disabled: !canUndo,
      onClick: onUndo,
      title: 'Undo',
    },
    {
      key: 'import',
      cssClass: 'ca-scheduler-header__import-button',
      iconCss: 'e-upload-1',
      disabled: false,
      onClick: onImport,
      title: 'Import',
    },
    {
      key: 'export',
      cssClass: 'ca-scheduler-header__export-button',
      iconCss: 'e-download',
      disabled: false,
      onClick: onExport,
      title: 'Export',
    },
  ];

  if (!showAdd) {
    buttons.shift(); // Remove the "Add" button if showAdd is false
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
      {buttons.map((button) => (
        <ButtonComponent
          key={button.key}
          cssClass={`ca-scheduler-header__button ${button.cssClass}`}
          aria-label={button.title}
          iconCss={button.iconCss ? `e-icons ${button.iconCss}` : undefined}
          title={button.title}
          onClick={button.onClick}
          disabled={button.disabled}
          style={{
            background: 'inherit',
            color: '#ffffff',
            boxShadow: 'none',
            border: 'none',
            padding: '7px',
            borderRadius: '0',
          }}
        >
          {button.customIcon && (
            <img
              src={button.customIcon}
              alt={button.title}
              width="20"
              height="20"
              style={{ display: 'block' }}
            />
          )}
        </ButtonComponent>
      ))}
    </div>
  );
}

export default SchedulerHeaderActions;
